import * as React from 'react';
import { isMbwayDetails } from './types.js';
import { MbwayContainer } from '../../../../PaymentMethods/Adyen/Mbway/containers/MbwayContainer.js';

const Mbway = ({ details , onChange  })=>{
    const initialValue = isMbwayDetails(details) ? details.phoneNumber : '+351';
    return /*#__PURE__*/ React.createElement(MbwayContainer, {
        initialValue: initialValue,
        onChange: onChange
    });
};

export { Mbway };
//# sourceMappingURL=Mbway.js.map
